import { Autocomplete, Grid, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CountryRegionData } from "react-country-region-selector";


export const SelectCountryAndRegion = (props) => {

    const [paisNac, setPaisNac] = useState([]);
    const [edoNac, setEdoNac] = useState([]);
    const [countries, setCountries] = useState([]);

    const [country, setCountry] = useState("");
    const [region, setRegion] = useState("");

    const getEstados = (pais) => {
        if (pais !== null) {
            setEdoNac( countries.find( (item) => item.name === pais ).regions );
        } else {
            setEdoNac([]);
        }
        setCountry(pais);
        props.parentCallback({ country:pais, region:"" })
    }
    const handleEdos = (edo) => {
        
        setRegion(edo);
        props.parentCallback({ country:country, region:edo });
    }

    useEffect(() => {
      
        const setCountriesAndRegions = () => {
            let countries = [];
            let paises = [];
            let regions = [];
            CountryRegionData.forEach( (item) => {
                // Limpiamos el arreglo
                regions = [];
                // Agregamos a «paises» unicamente los nombres de los paises
                paises.push(item[0]);
                // Agregamos a «regions» de cada elemento lo recuperado 
                // desde el inicio hasta una posicion antes del "~"
                item[2].split("|").forEach( (reg) => {
                    regions.push( reg.slice(0, reg.indexOf("~")) )
                })
                // Agregamos a «countries» el nombre del pais y las regiones recuperadas
                countries.push({name:item[0], regions:regions});
            } )
            // Establecemos los diferentes elementos con la info procesada 
            setCountries(countries);
            setPaisNac(paises);
        }
        setCountriesAndRegions();

    }, [ ])
    
    
    return (
        <Grid container spacing={2} sx={{ pt: props.paddingV, pb: props.paddingV, pl: props.paddingH, pr: props.paddingH }}>
            <Grid item xs={12} >
                <Autocomplete
                    onChange={(_, pais) => getEstados(pais)}
                    options={paisNac}
                    renderInput={(params) => (
                        <TextField {...params} 
                            label="País | Country *" 
                            variant={props.variant} 
                            size="small"
                        />
                    )}
                />
            </Grid>
            <Grid item xs={12} >
                <Autocomplete
                    disabled={!edoNac.length}
                    autoComplete={false}
                    key={edoNac}
                    onChange={(_, edo) => handleEdos(edo)}
                    options={edoNac}
                    renderInput={(params) => (
                        <TextField {...params} 
                            label="Estado | State *" 
                            variant={props.variant}
                            size="small"
                        />
                    )}
                />
            </Grid>
        </Grid>
    );
};
